import { Pipe, PipeTransform } from '@angular/core';
import { TitleCasePipe } from '@angular/common';

@Pipe({
  name: 'enumFormat',
})
export class EnumFormatPipe implements PipeTransform {
  constructor(private titleCasePipe: TitleCasePipe) {}

  transform(value: any, delimiter: string, newDelimiter = ' '): string {
    const formatted = value
      ? this.titleCasePipe.transform(value.replace(new RegExp(delimiter, 'g'), ' '))
      : '';

    return newDelimiter === ' ' ? formatted : formatted.replace(new RegExp(' ', 'g'), newDelimiter);
  }
}
